import { getReservations } from './reservationsApi';
import { requestJson } from './http';

export function getDashboardRecords(params = {}) {
  return getReservations(params);
}

export function getSlotSummaryRecords(params = {}) {
  return getReservations(params);
}

export function getSlotSummary(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value != null && value !== '') search.set(key, value);
  });
  const query = search.toString();
  return requestJson(`/api/analytics/slot-summary${query ? `?${query}` : ''}`);
}

export function lockSlot(payload = {}) {
  return requestJson('/api/slot-locks/lock', {
    method: 'POST',
    body: JSON.stringify(payload || {})
  });
}

export function unlockSlot(payload = {}) {
  return requestJson('/api/slot-locks/unlock', {
    method: 'POST',
    body: JSON.stringify(payload || {})
  });
}

export function getSlotLockDetails(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value != null && value !== '') search.set(key, value);
  });
  return requestJson(`/api/slot-locks?${search.toString()}`);
}

export function getSlotLockHistory(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') search.set(key, value);
  });
  return requestJson(`/api/slot-locks/history?${search.toString()}`);
}

export function getSlotAnalyticsRecords(params = {}) {
  return getReservations(params);
}
